import {
  FAQS,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
  REGISTRATION_TERMS_AND_CONDITIONS,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const buckeyes_bball: TTeamConfig = {
  TEAM_SCHEMA: "buckeyes_bball",
  TEAM_FULL_NAME: "Ohio State University",
  BROWSER_TITLE: "Buckeyes Flex Pass",
  CLIENT_ID: "332b7a436b2b.seasonshare.buckeyes-buckeyes.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/buckeyes/",
    COLORS_PRIMARY: "#ba0c2f",
    COLORS_SECONDARY: "#a7b1b7",
    DEFAULT_APP_ROUTE: routes.landing,

    IS_INTERCOM_ENABLED: true,
    IS_CROWD_HANDLER_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
      HIDE_PURCHASE_HISTORY: true,
    },
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
    },
    PASS: {
      SUBSCRIBE_BUTTON_TEXT: "Buy Now",
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTRATION_TERMS_AND_CONDITIONS />,
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },
    ADD_DARK_OVERLAY: true,
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio-State-Buckeyes.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Ohio%20State/Ohio%20State-MBB_FlexPass_2025Sep3_1920x450.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
  },
};
